enum TransportLocationStatus {
	// NOT_STARTED = null,
	HEADING_TO = 'headingTo',
	ARRIVED = 'arrived',
	TRANSSHIPPING = 'transshipping',
	FINISHED = 'finished'
}

export default TransportLocationStatus
